import { SnappyIntegrationConfig } from 'settings/Settings.types';

export function isSnappyIntegrationActive(
  config: SnappyIntegrationConfig
): boolean {
  return config.active && Boolean(config.apiKey);
}

export function isInitializingSnappyIntegration(
  config: SnappyIntegrationConfig
): boolean {
  return config.active && !config.apiKey;
}
